import { Injectable } from "@angular/core";
import { HttpClient, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";
import { MedID } from "@mk/med-ui";
import { ApiCoreService } from "@app/services/api.cpre.service";
import { env } from "@environments/environment";

// import { environment } from "environments/environment";
// import { ApiCoreService } from "app/api/api-core.service";
// import { Document } from "app/types/API/Document";
// import { ListPaginationResponse } from "app/types/API/ListPaginationResponse";

@Injectable({
  providedIn: "root",
})
export class DocumentFileApiService {
  constructor(private apiCoreService: ApiCoreService, private http: HttpClient) { }

  private _baseUrl = `${env.documentApi}/documents`;

  getBaseUrl(): string {
    return this._baseUrl;
  }

  getList(documentId: MedID): Observable<any> {
    return this.http.get(`${this._baseUrl}/${documentId}/files/search`);
  }

  uploadFile<ResponseType>(documentId: MedID, form: FormData): Observable<HttpEvent<ResponseType>> {
    return this.apiCoreService.upload<ResponseType>(`${this._baseUrl}/${documentId}/files`, form);
  }

  // downloadFile(fileId: number): Observable<any> {
  //   return this.apiCoreService.getBlob(`${this._baseUrl}/${fileId}/files`);
  // }

  // archive(fileId: number): Observable<Document.File> {
  //   return this.apiCoreService.patch<Document.File>(`${this._baseUrl}/${fileId}/files/archived`);
  // }

  // activate(fileId: number): Observable<Document.File> {
  //   return this.apiCoreService.patch<Document.File>(`${this._baseUrl}/${fileId}/files/activated`);
  // }
}
